import React from 'react';
import moment from 'jalali-moment';

/*
    - ihoDesignSystem
*/
import { Button, Grid, TextField, Select, Calendar, Box, Image } from '@iho-design-system/Loader';

/*
    - icon
*/
import CalendarSVG from '../../../assets/images/icons/calendar-blue.svg';
import CloseSVG from '../../../assets/images/icons/close.svg';

/*
    - api
*/
import walletReportExportAPI from '../../../api/get/WalletReportExport';

const Toolbar = ({ searchProps }) => {

    /*
        - defaultData
    */
    const type = localStorage.getItem('type');
    const [searchData, setSearchData] = React.useState({
        TransType: '-1',
        DocType: '2',
        StartDate: '',
        EndDate: ''
    });
    const [searchStartDate, setSearchStartDate] = React.useState('');
    const [searchEndDate, setSearchEndDate] = React.useState('');

    /*
        - searchHandler
    */
    const searchHandler = (key, value) => {
        if (key === 'transType') {
            setSearchData({
                ...searchData,
                TransType: value
            });
        }
        if (key === 'docType') {
            setSearchData({
                ...searchData,
                DocType: value
            });
        }
    }

    /*
        - advancedSearchProps
    */
    const search = () => {
        searchData.section = 'report';
        searchData.StartDate = (searchStartDate !== '') ? moment.from(searchStartDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : '';
        searchData.EndDate = (searchEndDate !== '') ? moment.from(searchEndDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : '';
        searchProps(searchData);
    }

    /*
        - clearDate
    */
    const clearDate = (calendar) => {
        if (calendar === 'searchStartDate') {
            setSearchStartDate('');
        }
        if (calendar === 'searchEndDate') {
            setSearchEndDate('');
        }
    }

    /*
        - downloadLink
    */
    const downloadLink = async () => {
        let parameters = {};
        parameters.TransType = searchData.TransType;
        parameters.DocType = searchData.DocType;
        parameters.StartDate = searchData.StartDate;
        parameters.EndDate = searchData.EndDate;
        await walletReportExportAPI(parameters);
    }

    /*
        - toggleCalendar
    */
    const toggleCalendar = (event, calendar) => {
        if (event.target.tagName === 'DIV' || event.target.tagName === 'INPUT') {
            document.querySelector(`.${calendar}`).classList.toggle('d-none');
        }
    }

    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper>
                    <Grid.Item
                        size='col-12 lg-2 md-2'>
                        <Select
                            onChange={(value) => searchHandler('transType', value)}
                            label='وضعیت تراکنش'
                            init={searchData.TransType}>
                            <Select.Item
                                value='-1'>
                                همه
                            </Select.Item>
                            <Select.Item
                                value='0'>
                                برداشت
                            </Select.Item>
                            <Select.Item
                                value='1'>
                                واریز
                            </Select.Item>
                        </Select>
                    </Grid.Item>
                    <Grid.Item
                        size='col-12 lg-2 md-2'>
                        <Select
                            onChange={(value) => searchHandler('docType', value)}
                            label='نوع تراکنش'
                            init={searchData.DocType}>
                            <Select.Item
                                value='2'>
                                کیف پول
                            </Select.Item>
                            {type === 'B2B' &&
                                <React.Fragment>
                                    <Select.Item
                                        value='4'>
                                        اعتبار
                                    </Select.Item>
                                    <Select.Item
                                        value='5'>
                                        شارژ اعضا
                                    </Select.Item>
                                </React.Fragment>
                            }
                        </Select>
                    </Grid.Item>
                    <Grid.Item
                        className={`position-relative`}
                        size='col-12 lg-2 md-4'>
                        <Box
                            onClick={(event) => toggleCalendar(event, 'reserveStartDateCalendar')}>
                            <TextField
                                variant='outlined'
                                label='از تاریخ'
                                value={searchStartDate}
                                placeholder='روز/ماه/سال'
                                ms={{
                                    'input': {
                                        paddingRight: '35px'
                                    }
                                }} />
                            <Image
                                className={`pointer position-absolute`}
                                src={CalendarSVG}
                                ms={{
                                    width: '16px',
                                    height: '16px',
                                    top: '47px',
                                    right: '20px'
                                }} />
                            {searchStartDate !== '' &&
                                <Image
                                    onClick={() => clearDate('searchStartDate')}
                                    className={`pointer position-absolute`}
                                    src={CloseSVG}
                                    ms={{
                                        width: '16px',
                                        height: '16px',
                                        top: '47px',
                                        left: '20px'
                                    }} />
                            }
                            <Box
                                className={`d-none reserveStartDateCalendar position-absolute`}
                                ms={{
                                    width: '320px',
                                    top: 'calc(75px + var(--sizing-xs))',
                                    zIndex: '1'
                                }}>
                                <Calendar
                                    onChange={(event) => setSearchStartDate(event)} />
                            </Box>
                        </Box>
                    </Grid.Item>
                    <Grid.Item
                        className={`position-relative`}
                        size='col-12 lg-2 md-4'>
                        <Box
                            onClick={(event) => toggleCalendar(event, 'reserveEndDateCalendar')}>
                            <TextField
                                variant='outlined'
                                label='تا تاریخ'
                                value={searchEndDate}
                                placeholder='روز/ماه/سال'
                                ms={{
                                    'input': {
                                        paddingRight: '35px'
                                    }
                                }} />
                            <Image
                                className={`pointer position-absolute`}
                                src={CalendarSVG}
                                ms={{
                                    width: '16px',
                                    height: '16px',
                                    top: '47px',
                                    right: '20px'
                                }} />
                            {searchEndDate !== '' &&
                                <Image
                                    onClick={() => clearDate('searchEndDate')}
                                    className={`pointer position-absolute`}
                                    src={CloseSVG}
                                    ms={{
                                        width: '16px',
                                        height: '16px',
                                        top: '47px',
                                        left: '20px'
                                    }} />
                            }
                            <Box
                                className={`d-none reserveEndDateCalendar position-absolute`}
                                ms={{
                                    width: '320px',
                                    top: 'calc(75px + var(--sizing-xs))',
                                    zIndex: '1'
                                }}>
                                <Calendar
                                    onChange={(event) => setSearchEndDate(event)} />
                            </Box>
                        </Box>
                    </Grid.Item>
                    <Grid.Item
                        className={`d-flex justify-content-end`}
                        size='col-12 lg-4'>
                        <Button
                            onClick={() => downloadLink()}
                            variant='outlined'
                            color='primary'
                            ms={{
                                marginTop: '28px',
                                '@media(max-width:992px)': {
                                    marginTop: '0'
                                }
                            }}>
                            دانلود جدول
                        </Button>
                        <Box
                            className={`mx-xs`} />
                        <Button
                            onClick={search}
                            color='primary'
                            ms={{
                                marginTop: '28px',
                                '@media(max-width:992px)': {
                                    marginTop: '0',
                                }
                            }}>
                            جستجو
                        </Button>
                    </Grid.Item>
                </Grid.Wrapper>
            </Grid>
        </React.Fragment>
    );

}

export default Toolbar;